import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden, Button } from '@mui/material'
import { styled } from '@mui/material/styles';

import Moment from 'moment'
import 'moment/locale/fr';

import APIS from "../../../utils/APIS"
import progressionKeys from "../../../utils/progressionKeys"


import SelectEcoleMenuMobile from "./SelectEcoleMenuMobile"
import MyPopover from "../MyPopover"

import { Header, CardContainer, FiltersDisplay, FilterList, ItemPopover, FiltresInline  } from "./Suivi"
import { ModalTuto } from "./Home"

import ProgressionChart from "./ProgressionChart"
import NoDataScreen from "./NoDataScreen"
import SkeletonEcran from "./SkeletonEcran"
// E1 review 02/09 : Rapport d'impact PDF, par promo (meme mecanique que le
// Rapport recruteur de THE SCAN)
import RapportImpact from "./RapportImpact"
import PhraseInsight from "./PhraseInsight"
import { usePDF } from 'react-to-pdf'
import { v4 as uuidv4 } from 'uuid';
import PopupNotifContext from "../../../contexts/PopupNotifContext"
import exportIcon from "../../../images/exportIcon.svg"


import UserAdminClientContext from "../../../contexts/UserAdminClientContext"
import LanguageContext from "../../../contexts/LanguageContext"

import moyenneIcon from "../../../images/moyenneIcon.svg"
import modulesIcon from "../../../images/modulesIcon.svg"
import moyenneTempsIcon from "../../../images/moyenneTempsIcon.svg"
import etudiantsTotIcon from "../../../images/etudiantsTotIcon.svg"
import searchIcon from "../../../images/searchIcon.svg"
import filterIcon from "../../../images/filterIcon.svg"
// Point 12 de la review du 04/08 : une icône par filtre (cf Suivi.js).
import filtreCertificationIcon from "../../../images/filtreCertificationIcon.svg"
import filtreDiplomeIcon from "../../../images/filtreDiplomeIcon.svg"
import filtreAnneeCertifIcon from "../../../images/filtreAnneeCertifIcon.svg"
import filtreAnneeEtudeIcon from "../../../images/filtreAnneeEtudeIcon.svg"
import cardIcon from "../../../images/cardIcon.svg"
import sablierIcon from "../../../images/sablierIcon.svg"
import progressionUpArrow from "../../../images/progressionUpArrow.svg"
import progressionDownArrow from "../../../images/progressionDownArrow.svg"
import progressionStableArrow from "../../../images/progressionStableArrow.svg"



Moment.locale('fr')

const ActionList = ({ filters, setFilters, icebreakerQuestions }) => {
  const {
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [actItem, setActItem] = useState(null)
  const menuOpenClose = (item) => {
    if (item === actItem) {
      setActItem(null)
    } else {
      setActItem(item)
    }
  }

  return (
    <Box sx={{display:"flex", alignItems:"flex-start"}}>
      <Box sx={{
        minWidth:"220px",
        maxWidth:"350px",
        padding:"10px 20px",
        boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
        border: "1px solid rgba(206, 206, 206, 0.5)",
        borderRadius: "6px",
        background:"white",
      }}>
        {actEcole?.groupes?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.groupe[actLanguage]}
              onClick={() => {menuOpenClose("groupe")}} selected={actItem === "groupe"} icon={filtreCertificationIcon}
            />
            <Hidden mdUp>
              {actItem === "groupe" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                  datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
                  onlyOneSelection={true}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.secteurs === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.sector[actLanguage]}
              onClick={() => {menuOpenClose("secteur")}} selected={actItem === "secteur"} icon={filtreDiplomeIcon}
            />
            <Hidden mdUp>
              {actItem === "secteur" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.sectorSub[actLanguage]}
                  datas={icebreakerQuestions.secteursReps} filterType="secteur" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {actEcole?.campus?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.campus[actLanguage]}
              onClick={() => {menuOpenClose("campus")}} selected={actItem === "campus"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "campus" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                  datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.diplome === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.graduationYear[actLanguage]}
              onClick={() => {menuOpenClose("diplome")}} selected={actItem === "diplome"} icon={filtreAnneeCertifIcon}
            />
            <Hidden mdUp>
              {actItem === "diplome" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                  datas={icebreakerQuestions.diplomeReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.annees === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.studyYear[actLanguage]}
              onClick={() => {menuOpenClose("etude")}} selected={actItem === "etude"} icon={filtreAnneeEtudeIcon}
            />
            <Hidden mdUp>
              {actItem === "etude" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                  datas={icebreakerQuestions.anneesReps}
                  filterType="anneesEtude" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
      </Box>
      <Hidden mdDown>
        {actItem !== null &&
          <Box sx={{
            marginLeft:"10px",
            maxWidth:"350px",
            minWidth:"200px",
            padding:"10px 20px",
            boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
            border: "1px solid rgba(206, 206, 206, 0.5)",
            borderRadius: "6px",
            background:"white",
          }}>
            {actItem === "groupe" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
                onlyOneSelection={true}
              />
            }
            {actItem === "campus" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "secteur" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.sectorSub[actLanguage]}
                datas={icebreakerQuestions.secteursReps} filterType="secteur" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "diplome" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                datas={icebreakerQuestions.diplomeReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "etude" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                datas={icebreakerQuestions.anneesReps} filterType="anneesEtude" filters={filters} setFilters={setFilters}
              />
            }
          </Box>
        }
      </Hidden>
    </Box>
  )
}

let defautFilters = {
  groupes : [],
  campus : [],
  secteur : [],
  anneesEtude : [],
  anneesDiplome : []
}

const Progression = ({ }) => {

  const {
    ecoles,
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)
  const { addPopupNotif } = useContext(PopupNotifContext)  // E6 : toast d'export

  const [seeTuto, setSeeTuto] = useState(false)

  const [dataLoaded, setDataLoaded] = useState(false)
  // E2 review 02/09 : vrai etat « pas de donnees » au lieu d'un chargement sans fin
  const [aucuneDonnee, setAucuneDonnee] = useState(false)
  // Relecture finale 02/09 : distinguer « rien a montrer » de « serveur muet »
  const [reseauCoupe, setReseauCoupe] = useState(false)
  const [glbData, setGlbData] = useState(null)

  const [seuilsGraph, setSeuilsGraph] = useState(null)
  const [graphsData, setGraphsData] = useState([])

  const [filteredData, setFilteredData] = useState([])
  const [filteredStat, setFilteredStat] = useState({})

  /* B1 (retours Hicham 03/09) — ECRAN BLANC SUR PROGRESSION.
   *
   * Ces trois declarations vivaient APRES le memo `donneesRapport` ci-dessous,
   * qui lit `filters` dans son corps ET dans sa liste de dependances. Or cette
   * liste est evaluee des le premier rendu : `filters` etait donc lu avant sa
   * ligne `const`, ce que JavaScript refuse — « Cannot access 'filters' before
   * initialization ». Le composant levait une exception au montage et l'ecran
   * restait blanc, pour toutes les ecoles.
   *
   * Regression introduite le 02/09 en memorisant `donneesRapport` : tant que ce
   * calcul vivait dans le corps du rendu, il s'executait apres les `useState` et
   * le probleme n'existait pas. Le 500 du modele masquait ce plantage : l'ecran
   * n'arrivait jamais jusque-la. Corriger le serveur l'a rendu visible.
   *
   * ⛔ Ne jamais redescendre ces lignes sous le memo.
   * Cf JOURNAL-DES-ERREURS.md, motif M13. */
  const [filters, setFilters] = useState(defautFilters)
  const [popoverFilters, setPopoverFilters] = useState(false)
  const popoverRef = useRef()

  /* ---- E1 : export « Rapport d'impact » (PDF par promo) ---- */
  const { toPDF, targetRef } = usePDF({
    filename : "Rapport d'impact " + (actEcole?.name || "") + " - " + Moment().format("DD-MM-YYYY") + ".pdf",
    resolution: 2,
    page: { orientation: "portrait", margin: 0, format: [1250/4, 1768.0000001/4] },
  })
  // Relecture 02/09 (3e passe) : memorise. Sans cela, l'objet change d'identite
  // a chaque rendu et React reconstruit les 7 pages du rapport (1250x1768 chacune,
  // montees en permanence hors ecran pour que react-to-pdf trouve sa reference)
  // au moindre clic de filtre.
  const donneesRapport = React.useMemo(() => {
    // connaissance globale : moyenne ponderee des tranches du graphe
    let totEleves = 0, totAvant = 0, totApres = 0
    graphsData?.forEach((t) => {
      const n = t?.nbrStudents || 0
      totEleves += n
      totAvant += (t?.moyStartScore || 0) * n
      totApres += (t?.moyEndScore || 0) * n
    })
    const connaissance = {
      avant : totEleves > 0 ? totAvant / totEleves : 0,
      apres : totEleves > 0 ? totApres / totEleves : 0,
    }
    // competences : moyennes avant/apres deja calculees, famille retrouvee
    // dans la declaration softSkills des contenus
    const competences = (filteredData || []).map((skill) => {
      let family = null
      glbData?.contentsPerGroup?.forEach((g) => g?.contents?.forEach((content) => {
        const trouve = content?.softSkills?.find((el) => el.key === skill.key)
        if (trouve?.family && !family) family = trouve.family
      }))
      /* 04/09 — COMBIEN d'apprenants sont derriere chaque moyenne.
         Sans ce compte, le rapport ne peut pas distinguer « mesure a 0 % » de
         « pas encore mesure » : les deux arrivaient en 0, et le PDF imprimait
         « 72 % a 0 % » pour une competence dont le module de fin n'avait
         simplement pas encore ete passe. Une mesure absente presentee comme
         une mesure nulle — exactement la regle que Nawal applique partout :
         ne jamais afficher plus que ce qui a ete mesure. */
      return { key: skill.key, family: family || "efficacite",
        avant: skill?.first?.moyenne || 0, apres: skill?.last?.moyenne || 0,
        nbrDebut: skill?.first?.nbr || 0, nbrFin: skill?.last?.nbr || 0 }
    })
    // periode : bornes du plan du groupe filtre
    let actGroupe = actEcole?.groupes?.find((el) => el.groupeID === filters.groupes[0]) || actEcole?.groupes?.[0]
    const dates = (actGroupe?.plan?.plan || []).flatMap((m) => [m.openDate, m.closeDate]).filter(Boolean).sort()
    /* 04/09 — la periode suit la langue du rapport. `Moment.locale()` est
       GLOBAL : on ne le change pas ici, on demande la locale sur l'instance,
       sans quoi on deplacerait la langue de toutes les dates de l'application. */
    const localeRapport = actLanguage === "en" ? "en" : "fr"
    const moisDe = (d) => Moment(d).locale(localeRapport).format("MMMM YYYY")
    const periode = dates.length
      ? moisDe(dates[0]) + (localeRapport === "en" ? " to " : " à ") + moisDe(dates[dates.length-1])
      : "-"
    const etudiants = filteredStat.etudiantTot || 0
    /* R.3 (fiche V3 de Nawal) : le rapport a besoin du seuil de certification
       de chaque competence pour ecrire « le niveau atteint a permis sa
       certification » ou non. On lit la cle `validation` — et non `seuil`, qui
       n'existe pas en base, piege du 03/09. Un groupe peut fixer un seuil
       different par module : le dernier prime, c'est l'objectif d'arrivee. */
    const seuils = {}
    let certifGroupeRapport = actGroupe?.certification
    if (typeof certifGroupeRapport === "string") {
      try { certifGroupeRapport = JSON.parse(certifGroupeRapport) } catch (e) { certifGroupeRapport = null }
    }
    if (Array.isArray(certifGroupeRapport)) {
      certifGroupeRapport.forEach((mod) => (mod?.softSkills || []).forEach?.((sk) => {
        const val = parseInt(sk?.validation !== undefined ? sk.validation : sk?.seuil)
        if (sk?.key && !isNaN(val)) seuils[sk.key] = val
      }))
    }
    return {
      /* La langue du rapport voyage avec ses donnees : RapportImpact recoit
         `{...donneesRapport}`, il n'y a donc rien d'autre a cabler. */
      langue : actLanguage,
      seuils,
      ecoleName : actEcole?.name || "",
      groupeName : actGroupe?.name || "",
      diplomes : actGroupe?.diplome || "",
      periode,
      stats : {
        etudiants,
        /* 04/09 — DEUX NOMBRES, ET PAS UN SEUL. `etudiants` est l'effectif de la
           promotion filtree. `etudiantsMesures` est le nombre d'apprenants qui
           ont REELLEMENT une mesure de debut ET une mesure de fin : c'est la
           seule population sur laquelle la courbe de connaissance et le gain
           annonce sont calcules (totEleves, plus haut).
           Le rapport imprimait `etudiants` sous le libelle « etudiants
           mesures ». Sur une promotion de 1250 dont 938 ont passe le second
           scan, il annoncait donc 1250 mesures pour une evolution calculee sur
           938. Le chiffre le plus visible du document etait le mauvais. */
        etudiantsMesures : totEleves,
        /* Relecture du PDF genere, 03/09 : ce « taux de completion » rapportait
           les apprenants du graphe a eux-memes, il valait donc 100 % sur toutes
           les promotions et contredisait le Suivi. Il n'est plus envoye au
           rapport. `totEleves` reste utile pour la moyenne ponderee ci-dessus. */
        moyenne : filteredStat.moyenne !== undefined ? filteredStat.moyenne : "-",
        nbrModules : filteredStat.nbrModules || 0,
        nbrSoftSkills : competences.length,
      },
      connaissance,
      competences,
    }
  }, [graphsData, filteredData, filteredStat, glbData, actEcole, filters, actLanguage])



  useEffect(() => {
    setDataLoaded(false)
    if (actEcole?.groupes?.length > 0) {
      let fetchData = []
      actEcole?.groupes?.forEach((g) => {
        if (g.icebreaker !== null) {
          let ids = []
          let planByDate = JSON.parse(JSON.stringify(g?.plan?.plan)).sort(function(a,b){
            return new Date(a.closeDate) - new Date(b.closeDate);
          });
          planByDate?.forEach((p) => {
            ids.push(p.id)
          })
          fetchData.push({
            groupeID : g.groupeID,
            ids : ids,
            icebreaker : g.icebreaker
          })
        }
      })
      if (fetchData.length === 0) {
        setAucuneDonnee(true) // E2 : aucun groupe exploitable dans cette ecole
      } else {
        setAucuneDonnee(false)
        setReseauCoupe(false)
        APIS.clientAdminMapping({fetchData : fetchData}).then((result) => {
          if (result?.value?.length > 0) {
            let finalData = {
              contents : [],
              results : [],
              contentsPerGroup : [],
              nbrUsersTotal : 0
            }
            result?.value?.forEach((d) => {
              if (d.isOk === true && d.contents && d.results && d.users) {
                finalData.nbrUsersTotal += d.nbrUsersTotal

                d.contents.forEach((content) => {
                  content.groupeID = d?.groupeID
                  finalData.contents.push(content)
                })
                d.results.forEach((result) => {
                  //on va chercher ce user
                  let findUser = d?.users?.find((el) => el.id === result.userID)
                  result.groupeID = d?.groupeID
                  result.campusID = findUser?.campusID
                  finalData.results.push(result)
                })

                finalData?.contentsPerGroup?.push({
                  groupeID : d?.groupeID,
                  contents : d?.contents
                })
              }
            })


            //if (actEcole?.groupes?.length > 1) {
              setFilters({...filters,
                groupes : [actEcole?.groupes[0]?.groupeID]
              });
            //}

            setGlbData(finalData)
            setDataLoaded(true)
          } else {
            setDataLoaded(false)
            setAucuneDonnee(true)
            setReseauCoupe(result?.reseauIndisponible === true)
          }
        })
      }
    } else {
      // Relecture 02/09 (bis) : ecole sans aucun groupe, sinon chargement sans fin
      setAucuneDonnee(true)
    }
  }, [actEcole])

  useEffect(() => {
    if (glbData !== null && glbData.results && glbData.results.length > 0 && glbData.contents && glbData.contents.length > 0) {
      let newStats = {}
      let filtered = []
      let duplicateSkills = []
      let resultsForGraph = []
      //on regarde pour trouver des softskills présents dans plusieurs formations
      let actGroupe = actEcole?.groupes?.find((el) => el.groupeID === filters.groupes[0])
      let contentsForThisGroup = glbData?.contentsPerGroup?.find((el) => el.groupeID === filters.groupes[0])
      if (contentsForThisGroup && contentsForThisGroup?.contents?.length >= 0) {
        //stats
        newStats.nbrModules = contentsForThisGroup?.contents?.length
        let totalTime = 0
        contentsForThisGroup?.contents?.forEach((content) => {
          totalTime += content?.timing || 0
        })
        // A3 review 02/09 : meme calcul que le Suivi, la somme des durees,
        // pour une valeur unique et identique sur les deux ecrans
        newStats.averageTime = Math.round(totalTime)

        //on va regarder les résultats
        filtered = glbData.results
        if (filters.groupes.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.groupes.includes(el.groupeID)
          })
        }
        if (filters.campus.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.campus.includes(el.campusID)
          })
        }
        if (filters.secteur.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.secteur.includes(el.userResult_ice?.secteurs)
          })
        }
        /* Retours Hicham 03/09 (suite du point Suivi 1). Les deux filtres
           etaient croises : `anneesEtude` comparait le diplome et
           `anneesDiplome` comparait l'annee, l'inverse de ce que le Suivi fait
           des memes clefs. L'ecran restait coherent avec lui-meme parce que
           les listes proposees etaient croisees du meme cote, mais il
           annoncait « Annee d'etude » au dessus des diplomes. Les deux ecrans
           lisent desormais ces clefs de la meme facon. */
        if (filters.anneesEtude.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.anneesEtude.includes(el.userResult_ice?.annees)
          })
        }
        if (filters.anneesDiplome.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.anneesDiplome.includes(el.userResult_ice?.diplome)
          })
        }

        //pour graph, niveau de connaissance
        filtered.forEach((result) => {
          if (result["resultFin_ice"]) {
            let actResult = result["resultFin_ice"]
            if (actResult[progressionKeys?.start]) {
              resultsForGraph.push({
                userID : result?.userID,
                startScore : actResult[progressionKeys?.start]?.score || 0
              })
            }
          }
        })

        //calcul moyenne groupe
        let arrResults = []
        contentsForThisGroup?.contents?.forEach((content) => {
          arrResults.push("resultFin_"+content.id)
        })
        newStats.etudiantTot = filtered?.length
        let nbrResult = 0
        let totalResult = 0
        filtered.forEach((result) => {
          arrResults.forEach((resultKey) => {
            if (result[resultKey]) {
              let actResult = result[resultKey]
              // Number.isFinite et non « >= 0 » : null >= 0 est vrai en JS, un score de
              // module vide comptait 0 % (07/10/2026 : glbMaster vide si rien n'est coche)
              if (Number.isFinite(actResult?.glbMaster?.score)) {
                nbrResult += 1
                totalResult += actResult?.glbMaster?.score
              } else if (Number.isFinite(actResult?.master?.score)) {
                nbrResult += 1
                totalResult += actResult?.master?.score
              }
              //on regarde pour le niveau de connaissance de fin si on le trouve
              if (actResult[progressionKeys?.end]) {
                let findInResultsForGraph = resultsForGraph?.find((el) => el?.userID === result?.userID)
                if (findInResultsForGraph) {
                  findInResultsForGraph.endScore = actResult[progressionKeys?.end]?.score || 0
                }
              }
            }
          })
        })
        if (nbrResult > 0) {
          newStats.moyenne = parseInt(totalResult / nbrResult)
        } else {
          newStats.moyenne = "-"
        }

        //on trie pour graph, niveau de connaissance : on enlève si on a pas un startScore et un endScore
        resultsForGraph = resultsForGraph.filter((el) => el.startScore >= 0 && el.endScore >= 0)
      }

      //recherche pour liste des skills
      if (contentsForThisGroup && contentsForThisGroup?.contents?.length >= 2) {//il faut au moins 2 modules pour pouvoir comparer
        //on fait un tableau avec tous les skills de tous les modules de ce groupe
        let skillsPerContent = []
        contentsForThisGroup?.contents?.forEach((content) => {
          let contentIndexInPlan = actGroupe?.plan?.plan?.findIndex((el) => el.id === content.id)
          let skills = content?.softSkills?.filter((el) => el.value === "oui")
          skills.forEach((skill) => {
            skillsPerContent.push({
              key : skill.key,
              contentID : content.id,
              contentIndex : contentIndexInPlan,
            })
          })
        })

        //on regarde si on trouve des skills à comparer
        skillsPerContent.forEach((skill) => {
          let countThisSkill = skillsPerContent?.filter((el) => el.key === skill.key)
          if (countThisSkill?.length >= 2) {
            //on regarde si on le connait déjà
            let find = duplicateSkills.find((el) => el.key === skill.key)
            if (!find) {
              countThisSkill = countThisSkill?.sort((a, b) => {
                if (a.contentIndex < b.contentIndex) {
                  return -1;
                }
                if (a.contentIndex > b.contentIndex) {
                  return 1;
                }
                return 0;
              })
              duplicateSkills.push({
                key : skill.key,
                first : countThisSkill[0],
                last : countThisSkill[countThisSkill?.length - 1]
              })
            }
          }
        })

        //pour chaque skill, on va chercher les résultats de chaque user et on fait une moyenne avant / après
        duplicateSkills.forEach((skill) => {
          let totalFirst = 0
          let nbrFirst = 0
          let totalLast = 0
          let nbrLast = 0

          filtered.forEach((result) => {
            // Relecture finale 02/09 : un apprenant qui n'a pas passe le module
            // n'a pas de champ resultFin_<id> ; sans le `?.`, l'ecran Progression
            // plantait des qu'une promotion comptait un apprenant en retard.
            let resultFirst = result["resultFin_"+skill?.first?.contentID]
            if (resultFirst?.[skill?.key]?.score >= 0) {
              totalFirst += resultFirst[skill?.key]?.score
              nbrFirst += 1
            }

            let resultLast = result["resultFin_"+skill?.last?.contentID]
            if (resultLast?.[skill?.key]?.score >= 0) {
              totalLast += resultLast[skill?.key]?.score
              nbrLast += 1
            }
          })

          skill.first.nbr = nbrFirst
          skill.first.total = totalFirst
          if (nbrFirst > 0) {
            skill.first.moyenne = totalFirst / nbrFirst
          } else {
            skill.first.moyenne = 0
          }

          skill.last.nbr = nbrLast
          skill.last.total = totalLast
          if (nbrLast > 0) {
            skill.last.moyenne = totalLast / nbrLast
          } else {
            skill.last.moyenne = 0
          }
        })

        //on va calculer la progression
        duplicateSkills.forEach((skill) => {
          skill.progression = Math.round( (skill?.last?.moyenne - skill?.first?.moyenne) * 100 ) / 100
        })

        //on trie en fonction de la progression, de la plus grande vers la plus petite
        duplicateSkills = duplicateSkills?.sort((a, b) => {
          if (a.progression > b.progression) {
            return -1;
          }
          if (a.progression < b.progression) {
            return 1;
          }
          return 0;
        })
        //console.log(duplicateSkills)
      }

      //on calcule pour le graph
      let tranchesGraph = [
        { label: "0/4.9", max : 5, students : [] },
        { label: "5/14.9", max : 15, students : [] },
        { label: "15/49.9", max : 50, students : [] },
        { label: "50/84.9", max : 85, students : [] },
        { label: "85/94.9", max : 95, students : [] },
        { label: "95/100", max : 101, students : [] } //on triche pour le 100 car juste "<"
      ]
      if (resultsForGraph?.length > 0) {
        /* Fiche v5 de Nawal, regle 1 : « toutes les tranches remplies ».
         *
         * Elles ne l'etaient jamais, et la cause n'est pas dans les donnees.
         * Les bornes ci-dessus (5, 15, 50, 85, 95) etaient comparees au SCORE de
         * l'apprenant : pour remplir « 0/4.9 » il aurait fallu des apprenants
         * sous 5 % de bonnes reponses, et pour « 95/100 » des apprenants au-dessus
         * de 95 %. Deux tranches sur six se remplissaient, les autres restaient
         * vides sur toutes les promotions.
         *
         * Or ces bornes sont des PERCENTILES, pas des scores : les libelles le
         * disent, les bulles au survol aussi (« parmi le Xe percentile »), et la
         * table de Nawal n'a de sens que lue ainsi — elle place « avant 30 » dans
         * la tranche « 0/4.9 », ce qui est absurde pour un score et evident pour
         * un rang.
         *
         * On classe donc les apprenants par leur score de depart, puis on les
         * repartit selon leur RANG dans la promotion. Les six tranches se
         * remplissent alors par construction, et le graphe dit enfin ce que ses
         * libelles annoncent. */
        const parScore = [...resultsForGraph].sort((a, b) => (a?.startScore || 0) - (b?.startScore || 0))
        const total = parScore.length
        parScore.forEach((result, index) => {
          // rang exprime en pourcentage de la promotion, de 0 a 100
          const percentile = total > 1 ? (index / (total - 1)) * 100 : 0
          const find = tranchesGraph.find((t) => percentile < t.max) || tranchesGraph[tranchesGraph.length - 1]
          find.students.push(result)
        })

        //pour chaque tranche, on calcul le nbr d'élèves, le startScore total, la moyenne startScore, le endScore total, et la moyenne endScore
        tranchesGraph.forEach((t) => {
          if (t?.students?.length > 0) {
            t.nbrStudents = t.students.length
            let totalStartScore = 0
            let totalEndScore = 0
            t?.students?.forEach((student) => {
              totalStartScore += student?.startScore || 0
              totalEndScore += student?.endScore || 0
            })

            t.totalStartScore = totalStartScore
            t.moyStartScore = t.totalStartScore / t.nbrStudents
            t.totalEndScore = totalEndScore
            t.moyEndScore = t.totalEndScore / t.nbrStudents
            t.progression = t.moyEndScore - t.moyStartScore
          } else {//pas d'élève
            t.nbrStudents = 0
            t.totalStartScore = 0
            t.moyStartScore = 0
            t.totalEndScore = 0
            t.moyEndScore = 0
            t.progression = 0
          }
        })

      }

      //on regarde pour le certification
      let seuilsForKnowledgeLevel = {
        before : 0,
        after : 0,
        find : false,
      }
      let certificationForKnowledge = null
      if (actEcole?.groupes?.length === 1) {
        certificationForKnowledge = actEcole?.groupes[0]?.certification
      } else if (actEcole?.groupes?.length > 1) {
        let actGroupeFilterID = filters.groupes[0]
        certificationForKnowledge = actEcole?.groupes?.find((el) => el.groupeID === actGroupeFilterID)?.certification
      }
      if (certificationForKnowledge) {
        let find = certificationForKnowledge.find((el) => el.id === "valuesForNiveauConnaissance")
        if (find) {
          seuilsForKnowledgeLevel = {
            before : find?.before || 0,
            after : find?.after || 0,
            find : true,
          }
        }
      }

      setSeuilsGraph(seuilsForKnowledgeLevel)
      setGraphsData(tranchesGraph)

      setFilteredData(duplicateSkills)
      setFilteredStat(newStats)
    }
  }, [glbData, filters, actEcole])



  return (
    <>
      <Hidden smUp>
        <SelectEcoleMenuMobile />
      </Hidden>

      <ModalTuto
        isOpen={seeTuto}
        onClose={() => {
          setSeeTuto(false)
        }}
        title={languageValues?.adminDashboard?.mappingPage?.tutoTitle[actLanguage]}
        subTitle={languageValues?.adminDashboard?.mappingPage?.tutoSubTitle[actLanguage]}
        videoUrl={null}
      />

      <Box
        sx={{
          flex:1,
          padding:["20px", "50px", "50px", "80px"],
          backgroundColor:"background.grey",
        }}
      >
        <Header
          title={languageValues?.adminDashboard?.mapping[actLanguage]}
          dataLoaded={dataLoaded && glbData !== null && filteredData.length !== 0}
          withTuto
          onClickTuto={() => { setSeeTuto(true) }}
        />

        {/* E1 review 02/09 : export du Rapport d'impact PDF de la promo */}
        {(dataLoaded && glbData !== null) &&
          <>
            <RapportImpact ref={targetRef} {...donneesRapport} />
            <Box sx={{display:"flex", justifyContent:"flex-end"}}>
              <Button
                variant="contained"
                sx={{
                  height:"40px !important",
                  minHeight:"40px !important",
                  flexShrink:0,
                  textTransform:"none",
                  background:"white",
                  color:"text.black",
                  boxShadow:"none",
                  border:"1px solid #E7E7E7",
                  fontSize:"14px !important",
                  gap:"8px",
                  minWidth:"0 !important",
                  '&:hover': {
                    background:"white",
                    border:"1px solid black",
                  },
                }}
                onClick={async () => { await toPDF(); addPopupNotif({ uuid : uuidv4(), title : languageValues?.notifExport[actLanguage], type : "confirm", removeAfter : 4000 }) }}
              >
                <img src={exportIcon} style={{width:"15px"}} />
                <span>{languageValues?.adminDashboard?.mappingPage?.exportImpact?.[actLanguage]}</span>
              </Button>
            </Box>
          </>
        }

        <Box sx={{
          display:"flex",
          width:"100%",
          flexDirection:["column", "column", "column", "row"],
          columnGap:"30px",
          rowGap:"15px",
        }}>
          <Box sx={{
            flex:0.6,
            background: "white",
            border:"1px solid #E7E7E7",
            /* D10 (03/09) : la carte avait une hauteur FIXE de 315 px avec
               `overflow: hidden`. La regle de positionnement, ajoutee sous
               l'axe, tombait donc hors cadre : elle etait dans le DOM et
               invisible a l'ecran. On rend la place necessaire — 70 px, mesures
               sur le rendu — plutot que de la laisser rognee. */
            height:["350px", "370px", "370px", "390px"],
            minHeight:["350px", "370px", "370px", "390px"],
            overflow:"hidden",
            paddingTop:["20px", "30px"],
            paddingBottom:["20px", "30px"],
            paddingRight:["20px", "30px"],
            paddingLeft:["20px", "20px"],
          }}>
            <ProgressionChart data={graphsData} seuils={seuilsGraph}/>
          </Box>
          <Box sx={{
            flex:0.4,
            display:"flex",
            flexWrap:"wrap",
            gap:["15px","15px","15px","20px"]
          }}>
            <CardContainer
              forMapping
              title={languageValues?.adminDashboard?.monitoringCards?.average[actLanguage]} unit="&nbsp;/100"
              value={filteredStat.moyenne !== undefined ? filteredStat.moyenne : "-"} icon={moyenneIcon} dataLoaded={dataLoaded}
            />
            <CardContainer
              forMapping
              title={languageValues?.adminDashboard?.monitoringCards?.time[actLanguage]} unit="&nbsp;MIN"
              value={filteredStat.averageTime !== undefined ? filteredStat.averageTime : "-"} icon={moyenneTempsIcon} dataLoaded={dataLoaded}
            />
            <CardContainer
              forMapping
              title={languageValues?.adminDashboard?.monitoringCards?.students[actLanguage]}
              value={filteredStat.etudiantTot !== undefined ? filteredStat.etudiantTot : "-"} icon={etudiantsTotIcon} dataLoaded={dataLoaded}
            />
            <CardContainer
              forMapping
              title={languageValues?.adminDashboard?.monitoringCards?.modules[actLanguage]}
              value={filteredStat.nbrModules !== undefined ? filteredStat.nbrModules : "-"} icon={modulesIcon} dataLoaded={dataLoaded}
            />
          </Box>
        </Box>

        {/* Roadmap Nawal : la phrase d'insight, meme logique que le PDF */}
        {(dataLoaded && glbData !== null) &&
          <PhraseInsight
            etudiants={donneesRapport?.stats?.etudiants}
            connaissance={donneesRapport?.connaissance}
            competences={donneesRapport?.competences}
          />
        }

        {(dataLoaded && glbData !== null) ? (
          <>
            <Box sx={{
              display:"flex",
              gap:"10px",
              justifyContent:"space-between",
            }}>
              <Box sx={{
                marginTop:"35px",
                display:"flex",
                gap:["8px", "8px", "15px", "15px"],
                flexDirection:["column", "column", "row", "row"],
                alignItems:"flex-start",
              }}>
                <Button
                  ref={popoverRef}
                  disabled={!dataLoaded}
                  variant="contained"
                  disableRipple
                  sx={{
                    height:"40px !important",
                    minHeight:"40px !important",
                    flexShrink:0,
                    textTransform:"none",
                    background:"white",
                    color:"text.black",
                    boxShadow:"none",
                    border:"1px solid #E7E7E7",
                    fontSize:"14px !important",
                    gap:"8px",
                    '&:hover': {
                      background:"white",
                      border:"1px solid black",
                    },
                  }}
                  onClick={() => { setPopoverFilters(true) }}
                >
                  <img src={searchIcon} style={{width:"14px"}} />
                  <span>
                    {languageValues?.adminDashboard?.filters?.addFilter[actLanguage]}
                  </span>
                </Button>
                {/* D9 review 02/09 : deroulants en ligne, avec les filtres que
                    porte reellement cet ecran (groupe, secteur, annees, diplome) */}
                <Hidden mdDown>
                  <FiltresInline
                    filters={filters} setFilters={setFilters}
                    menus={[
                      ...(actEcole?.groupes?.length > 1 ? [{ cle:"groupe", titre: languageValues?.adminDashboard?.filters?.groupe[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.groupeSub[actLanguage], datas: actEcole?.groupes, dataToDisplay:["diplome","name"], dataToCheck:"groupeID", filterType:"groupes" }] : []),
                      ...(actEcole?.icebreakerQuestions?.secteurs === true ? [{ cle:"secteur", titre: languageValues?.adminDashboard?.filters?.sector[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.sectorSub[actLanguage], datas: actEcole?.icebreakerQuestions?.secteursReps || [], filterType:"secteur" }] : []),
                      ...(actEcole?.icebreakerQuestions?.annees === true ? [{ cle:"annees", titre: languageValues?.adminDashboard?.filters?.studyYear[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage], datas: actEcole?.icebreakerQuestions?.anneesReps || [], filterType:"anneesEtude" }] : []),
                      ...(actEcole?.icebreakerQuestions?.diplome === true ? [{ cle:"diplome", titre: languageValues?.adminDashboard?.filters?.graduationYear[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage], datas: actEcole?.icebreakerQuestions?.diplomeReps || [], filterType:"anneesDiplome" }] : []),
                    ]}
                  />
                </Hidden>
                <FiltersDisplay isMapping filters={filters} setFilters={setFilters} contents={glbData.contents} defaultF={defautFilters}/>
              </Box>
            </Box>

            <Box sx={{
              marginTop:"25px",
              display:"flex",
              flexDirection:"row",
              flexWrap:"wrap",
              columnGap:"20px",
              rowGap:"10px",
            }}>
              {filteredData?.map((skill, index) => {
                /* Q2 (reponse d'Hicham 03/09) : le 50 % affiche partout etait un
                 * placeholder, jamais une vraie valeur. Deux causes :
                 *   1. la cle lue etait `seuil`, alors que la configuration du
                 *      groupe enregistre `validation` — la recherche ne trouvait
                 *      donc jamais rien et retombait systematiquement sur 50 ;
                 *   2. en l'absence de configuration, on affichait quand meme 50,
                 *      ce qui est un chiffre invente presente comme un seuil.
                 * On lit la bonne cle, et on n'affiche la ligne que si un seuil
                 * est reellement configure. */
                let seuilSkill = undefined
                let certifGroupe = actEcole?.groupes?.find((el) => el.groupeID === filters.groupes[0])?.certification
                  || actEcole?.groupes?.[0]?.certification
                if (typeof certifGroupe === "string") { try { certifGroupe = JSON.parse(certifGroupe) } catch (e) { certifGroupe = null } }
                if (Array.isArray(certifGroupe)) {
                  certifGroupe.forEach((mod) => (mod?.softSkills || []).forEach?.((sk) => {
                    const val = parseInt(sk?.validation !== undefined ? sk.validation : sk?.seuil)
                    if (sk?.key === skill?.key && !isNaN(val)) seuilSkill = val
                  }))
                }
                return (
                  <SkillCard
                    key={index}
                    name={skill?.key}
                    result={skill?.progression}
                    seuil={seuilSkill}
                  />
                )
              })}

            </Box>

            <MyPopover
              isDrawerOpen={popoverFilters}
              anchorEl={popoverRef.current}
              handleClose={() => { setPopoverFilters(false) }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <ActionList
                glbData={glbData}
                filters={filters}
                setFilters={setFilters}
                icebreakerQuestions={actEcole?.icebreakerQuestions}
              />
            </MyPopover>
          </>
        ) : (
          aucuneDonnee === true ? (
            <NoDataScreen reseau={reseauCoupe} />
          ) : (
          <SkeletonEcran />
          )
        )}


      </Box>

    </>
  )
}

const SkillCard = ({ name, result, seuil }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  return (
    <Box sx={{
      flexBasis:["100%", "100%", "100%", "calc(50% - 10px)"],
      background:"white",
      border:"1px solid #E7E7E7",
      height:["65px", "70px", "70px", "95px"],
      minHeight:["65px", "70px", "70px", "95px"],
      padding:["10px", "12px", "12px", "20px"],
      display:"flex",
      justifyContent:"space-between",
      gap:["10px", "15px", "15px", "20px"],
      alignItems:"center",
      overflow:"hidden"
    }}>
      <Box sx={{
        display:"flex",
        alignItems:"center",
        gap:["8px", "11px", "11px", "15px"],
        overflow:"hidden"
      }}>
        <Box sx={{
          width:["37px", "40px", "40px", "50px"],
          minWidth:["37px", "40px", "40px", "50px"],
          overflow:"hidden",
          aspectRatio:1,
        }}>
          <img src={cardIcon} style={{width:"100%"}}/>
        </Box>
        <Box sx={{
          whiteSpace:"noWrap",
          textOverflow:"ellipsis",
          overflow:"hidden",
          color:"text.black",
          fontSize:["16px", "18px", "18px", "22px"],
        }}>
          {/* D11 review 02/09 : premiere lettre en majuscule uniquement, le
              capitalize CSS majusculait chaque mot (« Influence Assertive ») */}
          {String(name || '').trim().charAt(0).toUpperCase() + String(name || '').trim().slice(1).toLowerCase()}
        </Box>
      </Box>
      <Box sx={{
        display:"flex",
        alignItems:"center",
        gap:["6px", "8px", "8px", "10px"],
        overflow:"hidden",
        flexShrink:0,
      }}>
        {(result >= 0 || result <= 0) ? (
          <>
            <Box sx={{
              display:"flex",
              alignItems:"center",
              position:"relative",
              width:["60px", "75px", "75px", "95px"],
              minWidth:["60px", "75px", "75px", "95px"],
              marginRight:"10px",
              userSelect:"none",
            }}>
              {(result >= -1 && result <= 1) &&
                <img src={progressionStableArrow} style={{width:"100%"}}/>
              }
              {result < -1 &&
                <img src={progressionDownArrow} style={{width:"100%"}}/>
              }
              {result > 1 &&
                <img src={progressionUpArrow} style={{width:"100%"}}/>
              }
            </Box>
            <Box sx={{
              display:"flex",
              flexDirection:"column",
              alignItems:"flex-end",
              minWidth:["55px", "65px", "65px", "85px"],
            }}>
              <Box sx={{
                color:"text.black",
                fontSize:["16px", "20px", "20px", "26px"],
                textAlign:"right"
              }}>
                {result > 0 && "+"}
                {result}%
              </Box>
              {/* A2/Figma review 02/09 : le seuil de certification sous la valeur.
                  Q2 du 03/09 : rien plutot qu'un 50 % invente quand aucun seuil
                  n'est configure pour la competence. */}
              {seuil !== undefined && seuil !== null &&
                <Box sx={{
                  color:"text.subTitle",
                  fontSize:["10px", "11px", "11px", "12px"],
                  whiteSpace:"nowrap",
                }}>
                  {(languageValues?.adminDashboard?.mappingPage?.seuilCertification?.[actLanguage] || "").replace("{seuil}", seuil)}
                </Box>
              }
            </Box>
          </>
        ) : (
          <Box sx={{
            display:"flex",
            gap:["6px", "8px", "8px", "8px"],
            alignItems:"center",
          }}>
            <Box sx={{
              width:["10px", "12px", "12px", "14px"],
              minWidth:["10px", "12px", "12px", "14px"],
              overflow:"hidden",
              aspectRatio:"14/17.22"
            }}>
              <img src={sablierIcon} style={{width:"100%"}}/>
            </Box>
            <Box sx={{
              color:"text.black",
              fontSize:["13px", "14px", "14px", "16px"]
            }}>
              {languageValues?.formation?.pending[actLanguage]}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default Progression
